import { Typography } from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { CompanyRole, EnumCurrency } from 'tdc-web-backend/enums/enums';
import { MilestoneDto } from 'tdc-web-backend/milestones/schemas';
import { useTranslation } from 'react-i18next';
import { TaskStatus } from '../../../../components/task-status/TaskStatus';
import { formatCurrency } from '../../../../utils/helpers';
import { GeneralPaymentTableProps } from '../../E2Ehomescreen/GeneralPaymentTable/GeneralPaymentTable';
import useUserCompany from '../../../../utils/hooks/useUserCompany';
import useMode from '../../../../utils/hooks/useMode';
import { EnumMode } from '../../../../utils/context/Mode.context';

const RecentPayments = ({ rows }: GeneralPaymentTableProps) => {
  const { t } = useTranslation();
  const { mode } = useMode();

  const getColabCompany = (value: MilestoneDto) =>
    mode === EnumMode.Client ? value?.sellerName : value?.buyerName;

  const columns: GridColDef[] = [
    {
      field: 'paymentStatus',
      headerName: t('common.status'),
      flex: 0.4,
      renderCell: (params: GridRenderCellParams) => <TaskStatus text={params.value} />,
    },
    {
      field: 'company',
      headerName: t('common.company'),
      flex: 0.8,
      renderCell: (params: GridRenderCellParams) => (
        <Typography sx={{ fontSize: '0.875rem' }}>{getColabCompany(params.row)}</Typography>
      ),
    },
    {
      field: 'budget',
      headerName: t('common.amount'),
      flex: 0.5,
      renderCell: (params: GridRenderCellParams) => (
        <Typography sx={{ fontSize: '0.875rem' }}>
          {formatCurrency(params.value, params.row.currency as EnumCurrency)}
        </Typography>
      ),
    },
  ];

  return (
    <DataGrid
      columns={columns}
      rows={rows}
      rowHeight={70}
      disableSelectionOnClick
      hideFooter
      sx={{ height: 284 }}
    />
  );
};

export default RecentPayments;
